module.exports = __webpack_public_path__ + "img/house-visiting.de809e75.png";